<nav class="navbar fixed-top navbar-expand-md d-flex justify-content-between">
      <div class="d-flex flex-column align-items-center">
        <button style="width: 60px" type="button" class="btn btn-primary" (click)="this.pullAll()">Pull
        </button>
        {{countdownDisplay}}
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <span *ngIf="activeExchange === EXCHANGES.bitfinex">Filter By ABOS Account ID</span>
        <div *ngIf="activeExchange === EXCHANGES.bitfinex">
          <div>
            <ng-select
              [items]="accounts"
              [multiple]="true"
              [closeOnSelect]="false"
              [searchable]="false"
              bindLabel="abosAccountId"
              placeholder="Filter by ABOS account"
              (ngModelChange)="handleAccountDisplay($event)"
              [(ngModel)]="selectedAccounts">
            </ng-select>
          </div>
        </div>
        <div class="d-flex justify-content-center align-content-center align-items-center">
          <div class="dropdown" *ngIf="activeExchange === EXCHANGES.bitfinex">
            <button class="btn btn-primary dropdown-toggle" id="operationsDropdown" type="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-2x fa-tasks" aria-hidden="true"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="operationsDropdown">
              <div class="dropdown-item" style="cursor: pointer" (click)="$event.stopPropagation()">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="exampleCheck1"
                         [(ngModel)]="showOnlyBitfinexEnabledAccounts">
                  <label class="form-check-label" for="exampleCheck1">Show only Bitfinex enabled positions</label>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-item" (click)="enableAllCurrencyForAllAccount()">
                Enable all currency
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-item" (click)="disableAllCurrencyForAllAccount()">
                Disable all currency
              </div>
            </div>
          </div>
        </div>


        <div *ngIf="loan && activeExchange === EXCHANGES.bitfinex" class="ms-4 d-flex">
          <div class="mb-2">
            <span>Notional Loan USD: {{notionalLoan.max | number}}</span>
            <progressbar class="loanProgressBar"
                         [ngClass]="notionalLoan.max > notionalLoan.value ? 'positiveProgressBar' : 'negativeProgressBar'"
                         [max]="notionalLoan.max > notionalLoan.value ? notionalLoan.max : notionalLoan.value"
                         [type]="'info'"
                         [value]="notionalLoan.max - notionalLoan.value">
              <b class="position-absolute">{{(notionalLoan.max - notionalLoan.value) | number}}</b>
            </progressbar>
          </div>
          <div class="mb-2 ms-3">
            <span>Active Loan USD: {{activeLoan.max | number}}</span>
            <progressbar class="loanProgressBar"
                         [ngClass]="activeLoan.max > activeLoan.value ? 'positiveProgressBar' : 'negativeProgressBar'"
                         [type]="activeLoan.max > activeLoan.value ? 'info' : 'danger'"
                         [max]="activeLoan.max > activeLoan.value ? activeLoan.max : activeLoan.value"
                         [value]="activeLoan.max - activeLoan.value">
              <b class="position-absolute">{{(activeLoan.max - activeLoan.value) | number}}</b>
            </progressbar>
          </div>
          <!--        <div class="mb-3 ms-3">-->
          <!--          <span>Current Equity USD: {{loan.minEquityInUSD}}</span>-->
          <!--          <progressbar class="loanProgressBar" [animate]="false" [max]="loan.minEquityInUSD" [value]="loan.currentEquityInUSD">-->
          <!--            <b>{{loan.currentEquityInUSD}}</b>-->
          <!--          </progressbar>-->
          <!--        </div>-->
          <div class="mb-2 ms-3" *ngIf="activeExchange === EXCHANGES.bitfinex">
            <span>FXCH limit: ({{maxAllocationAmountPercentage}}%)</span>
            <div class="fxchLimit"><b>${{loan.currentEquityInUSD | number}}</b></div>
          </div>
        </div>

        <div *ngIf="activeExchange === EXCHANGES.bitfinex  && currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_WRITE)">
          <button [disabled]="!isSweepEnabled" class="btn btn-primary ms-3" (click)="sweep()">Sweep</button>
        </div>

      </div>


      <div class="mr-5">
<!--        <button style="color:white;" class="btn" (click)="logout()">-->
<!--          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">-->
<!--            <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"/>-->
<!--            <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>-->
<!--          </svg>-->
<!--        </button>-->
        <!-- header.component.html -->

          <!-- Other components go here -->

        <baxter-library-profile [fillColor]="'white'"></baxter-library-profile>

<!--        -->
<!--        <button class="btn btn-primary" id="logout-button" (click)="logout()">-->
<!--          <i class="fa fa-2x fa-sign-out" aria-hidden="true"></i>-->
<!--        </button>-->
      </div>
    </nav>

